import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import CauHinhThongKeKhachHangApi from "service/CauHinhThongKeKhachHangApi";

/**
 * Xác nhận khóa / mở khóa 1 thuộc tính thống kê khách hàng.
 * Thuộc tính bị khóa vẫn giữ nguyên dữ liệu khách hàng cũ, chỉ không cho chọn mới nữa.
 */
const KhoaThuocTinh = ({ tab, data, onClose, onSearch }) => {
    const [saving, setSaving] = useState(false);

    const dangKhoa = data && data.IsActive === 0;
    const tieuDe = dangKhoa ? "Xác nhận mở khóa" : "Xác nhận khóa";
    const isActiveMoi = dangKhoa ? 1 : 0;

    const handleConfirm = async () => {
        try {
            setSaving(true);
            const res = await CauHinhThongKeKhachHangApi.capNhatTrangThai({
                loai: tab.loai,
                id: data.Id,
                isActive: isActiveMoi,
            });
            if (!res.ok) {
                pushNotification(
                    typeof res.data === "string" && res.data !== ""
                        ? res.data
                        : "Không thể cập nhật trạng thái. Vui lòng thử lại!",
                    "error",
                    "TOP_CENTER",
                    2000
                );
                return;
            }
            pushNotification(
                dangKhoa ? "Mở khóa thành công!" : "Khóa thành công!",
                "success",
                "TOP_CENTER",
                1000
            );
            onClose();
            onSearch();
        } catch (err) {
            console.error("Lỗi khi khóa/mở khóa:", err);
            pushNotification(
                err?.response?.data ||
                    "Không thể cập nhật trạng thái. Vui lòng thử lại!",
                "error",
                "TOP_CENTER",
                2000
            );
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            show={true}
            size="modal-dialog modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title">
                    <span className="btn-icon-right">
                        <i className={dangKhoa ? "mdi mdi-lock-open" : "mdi mdi-lock"}></i>
                    </span>
                    {tieuDe}
                </h4>
                <button type="button" className="close-popup-new" onClick={onClose}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <form className="form tat-toan form-horizontal">
                    <div className="form-body">
                        <div className="form-group row">
                            <label className="col-md-12 label-control text-left">
                                Bạn có chắc chắn muốn {dangKhoa ? "mở khóa" : "khóa"}{" "}
                                {tab.tenThuocTinh} <strong>"{data?.Ten}"</strong> không?
                            </label>
                        </div>
                        {!dangKhoa && (
                            <div className="form-group row">
                                <label className="col-md-12 label-control text-left canh-bao-red">
                                    Sau khi khóa, {tab.tenThuocTinh} này sẽ không còn hiển thị
                                    để chọn khi thêm/sửa khách hàng. Dữ liệu khách hàng đã gắn
                                    trước đó vẫn giữ nguyên.
                                </label>
                            </div>
                        )}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-checknew"
                    disabled={saving}
                    onClick={handleConfirm}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-check"></i>
                    </span>
                    Xác nhận
                </button>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onClose}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default KhoaThuocTinh;
